module.exports = __webpack_public_path__ + "img/job-special-risk.f75cfc9e.svg";